export default __webpack_public_path__ + "static/media/expressjs.9619a966.svg";